// #ifdef MP-WEIXIN
import zh from './mp-weixin/zh'
// #endif
// #ifdef H5
import zh from './h5/zh'
// #endif
// #ifdef APP-PLUS
import zh from './mp-weixin/zh'
// #endif

export default { zh }
